import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'javascripts/translations/i18n';
import { FILTER_PHOTOS_ONLY } from 'constants/filters';

import AssetFeed from 'components/assetFeed/AssetFeed';
import PickerFooter from './PickerFooter';
import { Modal } from '@companycam/slab-web';
import { useModal } from 'components/shared/hooks';
import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { v1URLsFromAsset } from 'helpers/asset-utils';

const VIEW_MENU_MOUNT_NODE_ID = 'asset-picker-modal';

const PageAssetPickerModal = ({ editor, projectNodeId }) => {
  const projectId = parseInt(graphQLIdDecoder(projectNodeId)?.databaseId);

  const { hideModal } = useModal();

  const assetFilters = {
    assetType: FILTER_PHOTOS_ONLY,
    capturedAfter: null,
    capturedBefore: null,
    projects: [],
    users: [],
    groups: [],
    tags: [],
  };

  const handleSelection = (photos) => {
    if (editor) {
      // Insert gallery images
      photos.forEach((photo) => {
        const { url_large, url_small } = v1URLsFromAsset(photo);
        editor
          .chain()
          .insertPhoto({
            imageId: photo.databaseId,
            src: url_small,
            originalSrc: url_large,
            timestamp: photo.timestamp,
          })
          .run();
      });
    }
    hideModal();
  };

  return (
    <Modal
      isOpen
      onClose={hideModal}
      size="large"
      headerStyle={{ borderBottomWidth: 0 }}
      bodyStyle={{ paddingTop: 0 }}
      title={translate('projectPage.assetPicker.title')}
    >
      <div id={VIEW_MENU_MOUNT_NODE_ID}>
        <AssetFeed
          projectDatabaseId={projectId}
          entityId={projectNodeId}
          multiSelectHandlerComponent={
            <PickerFooter onSelection={handleSelection} onCancel={hideModal} />
          }
          isPresentedInModal
          initialFilters={assetFilters}
          mountNodeId={VIEW_MENU_MOUNT_NODE_ID}
        />
      </div>
    </Modal>
  );
};

PageAssetPickerModal.propTypes = {
  editor: PropTypes.object.isRequired,
  projectNodeId: PropTypes.string.isRequired,
};

export default PageAssetPickerModal;
